module.exports = __webpack_public_path__ + "static/media/circle-check.0aee58d7.svg";